import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LanguageService } from '../services';
import LanguageSlice from '../common/slices/LanguageSlice';
import { AppDispatch } from '../reducers/store';

export default function useAllowedLanguages(languages?: string[]) {
    const dispatch = useDispatch<AppDispatch>();
    const prevLocale = useSelector(LanguageSlice.state.getPrevLocale);
    const locale = useSelector(LanguageSlice.state.getLocale);

    useEffect(() => {
        if (languages?.length && languages.length > 0) {
            dispatch(LanguageSlice.actions.changeAllowedLocales(languages));

            if (locale && !languages.includes(locale?.toLowerCase())) {
                dispatch(LanguageSlice.actions.changePrevLocale(locale));

                dispatch(
                    LanguageSlice.actions.changeLocale(
                        LanguageService.getDefaultLocale(languages),
                    ),
                );
            }
        }
    }, [dispatch, languages]);

    useEffect(() => {
        return () => {
            dispatch(LanguageSlice.actions.changeAllowedLocales([]));
            if (prevLocale && prevLocale !== locale) {
                dispatch(LanguageSlice.actions.changeLocale(prevLocale));
            }
        };
    }, []);
}
